<div class="container responsive-layout">
  <div class="row">
    <h1>{{ pageData.title }}</h1>
  </div>

  <span>{{ pageData.subTitle }}</span>

  @if (showDivider) {
    <hr />
  }

  @if(clientName()){
      <div class="dropdown-wrapper">
        <button (click)="toggleMenu()" title="Más acciones" class="menu-button">
          <div class="container-client">
            <img src="/assets/icons/office_bag.svg" alt="Icono" class="icon" />
            <span>Cliente: {{ clientName() }}</span>
            <img src="/assets/icons/flecha_1.svg" alt="Icono" class="icon" />
          </div>
        </button>
        @if(showMenu){
          <div class="dropdown-menu" >
            <ul>
              <li (click)="goToClients()"> Elegir otro cliente</li>
            </ul>
          </div>
        }
      </div>
    }
</div>
